module.exports = __webpack_public_path__ + "static/media/usercontext-pq-panel.56c0fd9f.svg";